import {Link} from 'react-router';

import MailIcon from '@/assets/icons/mail.svg?react';
import ContactUsForm from '@/features/contactUsForm';
import AppLogo from '@/shared/components/AppLogo';
import {BUMPY_INC} from '@/shared/consts/legal';
import {SUPPORT_EMAIL} from '@/shared/consts/socialLinks';
import {localize} from '@/shared/services/i18n';
import {localizeHref} from '@/sync/lib/localizeHref';
import Footer from '@/widgets/footer';
import {getLoginFooterInc} from '@/widgets/footer/consts';

export default function LangContacts() {
  return (
    <div>
      <div className="flex h-[80px] items-center justify-center bg-white sm:h-[100px]">
        <Link to="/">
          <AppLogo className="h-auto w-[75px] text-primary sm:w-[120px]" />
        </Link>
      </div>
      <div className="mx-auto w-full max-w-[1024px]">
        <div className="px-4 pt-5 pb-8 text-black sm:pb-12">
          <h1 className="mb-4 font-bold text-2xl sm:text-3xl">
            {localize('main_contact_us')}
          </h1>
          <p>{localize('contact_intro_title')}</p>
          <p>{localize('contact_intro_text')}</p>
        </div>
        <ContactUsForm />
        <div className="flex flex-col gap-4 px-4 py-12">
          <p className="font-semibold text-lg text-link sm:text-xl">
            {localize('contact_address_title')}
          </p>
          <p className="whitespace-pre-line text-base sm:text-lg">
            {BUMPY_INC.address.replaceAll(',', '\n')}
          </p>
        </div>
        <div className="flex flex-col gap-4 px-4 text-base sm:text-lg">
          <p>
            {localize('contact_terms_text')}
            <a
              href={localizeHref('/:lang?/terms-of-service')}
              className="cursor-pointer font-normal text-system-blue hover:accent-system-blue"
              target="_blank"
              rel="noopener noreferrer"
            >
              {localize('terms_of_service')}
            </a>
          </p>
          <p>
            {localize('contact_privacy_text')}
            <a
              href={localizeHref('/:lang?/privacy-policy')}
              className="cursor-pointer font-normal text-system-blue hover:accent-system-blue"
              target="_blank"
              rel="noopener noreferrer"
            >
              {localize('sign_policy_link')}
            </a>
          </p>
          <div className="flex flex-wrap items-center gap-2">
            <p>{localize('contact_email_text')}</p>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="flex cursor-pointer items-center font-normal text-system-blue hover:accent-system-blue"
            >
              <MailIcon className="mr-2 fill-dark-gray" />
              {SUPPORT_EMAIL}
            </a>
          </div>
        </div>
      </div>
      <Footer
        legal={BUMPY_INC}
        footerLinks={getLoginFooterInc()}
        contactLink={localizeHref('/:lang?/contacts')}
      />
    </div>
  );
}
